import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any;

@Component({
	selector: 'app-cricket',
	templateUrl: './cricket.component.html',
	styleUrls: ['./cricket.component.scss']
})
export class CricketComponent implements OnInit {

	bannerrequest: any = {};
	bannerList: any = "";

	constructor(private allpagesService: AllPageService,) { }
	slidevideoConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	ngOnInit() {
		this.loadBanner();
		jQuery('.popup-youtube').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});
	}

	loadBanner() {
		this.bannerrequest = {
			title: 'Mike Turner Indoor Cricket Centre'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			//console.log(this.bannerList);
		});
	}

}
